<template>
  <section class="section" dir="ltr">
    <div class="container" style="top: 50px;">
      <div class="columns">
        <div class="column is-one-third is-offset-4">
          <figure class="image is-128x128" style="margin: auto; bottom: 20px;">
            <img src="../assets/logo.png">
          </figure>
          <b-tabs type="is-boxed" dir="rtl">
            <b-tab-item label="دخول">
              <form @submit.prevent="validateForm('login')" data-vv-scope="login">
                <div v-if="getError.show" class="notification is-danger">
                  <button class="delete" @click="hideWarning"></button>
                  {{getError.message.message}}
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="email" id="logEmail" v-model="formLogin.logEmail" v-validate="'required|email'" name="log_email" :class="{'input': true, 'is-danger': errors.has('login.log_email') }" dir="ltr">
                    <span class="help is-danger" v-show="errors.has('login.log_email')">{{ errors.first('login.log_email') }}</span>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="envelope" />
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="password" v-model="formLogin.logPassword" v-validate="'required'" name="log_password" :class="{'input': true, 'is-danger': errors.has('login.log_password') }" dir="ltr">
                    <span class="help is-danger" v-show="errors.has('login.log_password')">{{ errors.first('login.log_password') }}</span>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="lock" />
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control">
                    <button class="button is-primary" type="submit" :class="{ 'is-loading': getLoader }">
                      دخول
                    </button>
                  </p>
                </div>
              </form>
            </b-tab-item>
            <b-tab-item label="تسجيل">
              <form @submit.prevent="validateForm('signup')" data-vv-scope="signup">
                <div v-if="getError.show" class="notification is-danger">
                  <button class="delete" @click="hideWarning"></button>
                  {{getError.message.message}}
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="email" id="signEmail" v-model="formSignup.signEmail" v-validate="'required|email'" name="sign_email" :class="{'input': true, 'is-danger': errors.has('signup.sign_email') }" dir="ltr">
                    <span class="help is-danger" v-show="errors.has('signup.sign_email')">{{ errors.first('signup.sign_email') }}</span>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="envelope" />
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="password" v-model="formSignup.signPassword" v-validate="'required|min:8'" name="sign_password" :class="{'input': true, 'is-danger': errors.has('signup.sign_password') }" dir="ltr" ref="signup.sign_password">
                    <span class="help is-danger" v-show="errors.has('signup.sign_password')">{{ errors.first('signup.sign_password') }}</span>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="lock" />
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="password" v-validate="'required|confirmed:signup.sign_password'" name="re_password" :class="{'input': true, 'is-danger': errors.has('signup.re_password') }" dir="ltr">
                    <span class="help is-danger" v-show="errors.has('signup.re_password')">{{ errors.first('signup.re_password') }}</span>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="lock" />
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control">
                    <button class="button is-primary" type="submit" :class="{ 'is-loading': getLoader }">
                      تسجيل
                    </button>
                  </p>
                </div>
              </form>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ar from 'vee-validate/dist/locale/ar'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'
library.add(faEnvelope)
library.add(faLock)

export default {
  data () {
    return {
      formLogin: {
        logEmail: null,
        logPassword: null
      },
      formSignup: {
        signEmail: null,
        signPassword: null,
        rePassword: null
      },
      dictionary: {
        ar: {
          attributes: {
            log_email: '"البريد الإلكتروني"',
            log_password: '"كلمة المرور"',
            sign_email: '"البريد الإلكتروني"',
            sign_password: '"كلمة المرور"',
            re_password: '"إعادة كلمة المرور"'
          },
          messages: {
            confirmed: function (n) { return `${n} لا تتطابق.` }
          }
        }
      }
    }
  },
  created () {
    this.$validator.localize('ar', ar)
    this.$validator.localize(this.dictionary)
  },
  methods: {
    validateForm: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (scope === 'login') {
            this.$store.dispatch('getAccount', this.formLogin)
          } else if (scope === 'signup') {
            // this.$store.dispatch('setAccount', this.formSignup)
            this.$store.dispatch('showLoader', true)
            let params = {
              appid: this.$store.state.config.XbAppID,
              email: this.formSignup.signEmail,
              password: this.formSignup.signPassword
            }
            this.XbortRequest('signup', 'post', params, result => {
              this.$store.dispatch('showLoader', false)
              if (result.result) {
                let params = {
                  appid: this.$store.state.config.XbAppID,
                  type: 'data',
                  request: 'km_profiles',
                  data: JSON.stringify({ userId: result.data.data.user, userEmail: this.formSignup.signEmail, userStatus: 'active' })
                }
                this.XbortRequest('', 'post', params, result => {
                  if (result.result) {
                    this.successMessage('تم التسجيل بنجاح! يرجى تأكيد التسجيل بتتبع الرابط المرسل إلى بريدكم.')
                  } else {
                    this.errorMessage(result.data)
                  }
                })
              } else {
                this.$store.dispatch('showLoader', false)
                this.errorMessage(result.data)
              }
            })
          }
        }
      })
    },
    hideWarning: function () {
      this.$store.dispatch('showError', { show: false, message: null })
    }
  },
  computed: {
    ...mapGetters([
      'getLoader',
      'getError'
    ])
  }
}
</script>
